import React, { useContext, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { Store } from "../../Store";

const ResetPassword = () => {
  const { state } = useContext(Store);
  const { baseUrl } = state;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const { token } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      const { data } = await axios.post(
        `${baseUrl}/user/reset-password/${token}`,
        { password }
      );
      setMessage(data.message);
    } catch (error) {
      setMessage("Error resetting password");
    }
  };

  const formContainerStyle = {
    marginTop: "5%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
  };

  const loginFormStyle = {
    width: "50%",
  };

  return (
    <div style={formContainerStyle}>
      <h2>Reset Password</h2>
      <Form style={loginFormStyle} onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>New Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" className="mt-3 w-100">
          Reset Password
        </Button>
      </Form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ResetPassword;
